<div class="d-flex gap-8">
  <app-icon class="item__icon">sync_problem</app-icon>
  <div class="flex-fill d-flex flex-column">
    <p class="item__message" [innerHTML]="message"></p>
    <p class="item__from-now">{{ _notification.created_at }}</p>
  </div>
</div>
